<button [disabled]="disabled" class="icon-button music-selection {{(itemIsPlayable$ | async) ? 'playable' : 'unplayable'}}" (click)="onTogglePlay($event)">
  @if (!(itemIsStarting$ | async) && itemIsPlaying$ | async) {
    <tun-pause-icon-v5 class="icon"></tun-pause-icon-v5>
  }
  @if (!(itemIsStarting$ | async) && !(itemIsPlaying$ | async)) {
    <tun-play-icon-v5 class="icon"></tun-play-icon-v5>
  }
  @if (itemIsStarting$ | async) {
    <mat-spinner class="music-selection-spinner"></mat-spinner>
  }
</button>
